module.exports = __webpack_public_path__ + "img/icon-header-myfolder.9e5843b.svg";